import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import {
  Button,
  PaneMenu,
} from '@folio/stripes/components';

const LastMenuButton = ({
  labelId,
  onClick,
  id,
}) => (
  <PaneMenu>
    <Button
      marginBottom0
      buttonStyle="primary"
      id={id}
      onClick={onClick}
    >
      <FormattedMessage id={`ui-task-list.${labelId}`} />
    </Button>
  </PaneMenu>
);

LastMenuButton.propTypes = {

  id: PropTypes.string.isRequired,
  labelId: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default LastMenuButton;
